import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { Members, ShareScreen } from "../screens/Club";
import {
  RouteProp,
  getFocusedRouteNameFromRoute,
} from "@react-navigation/native";
import { useLayoutEffect } from "react";
import { HomeTabsParamList } from "./HomeTabsNavigator";
import { MemberQueryRenderer } from "../screens/Member/MemberQueryRenderer";
import { EditProfileQueryRenderer } from "../screens/Club/EditProfile";
import { FriendsAndRequests } from "../screens/Club/FriendsAndRequests/FriendsAndRequests";
import { ProfileHome } from "../screens/Profile/ProfileHome";

export type ProfileNavigatorParamList = {
  ProfileHome: undefined;
  EditProfile: undefined;
  Members: undefined;
  Followers: undefined;
  Member: { id: string };
  FriendsAndRequests: undefined;
  Share: undefined;
};

const Stack = createNativeStackNavigator<ProfileNavigatorParamList>();

const tabBarHiddenRoutes = [
  "Share",
  "Member",
  "Members",
  "EditProfile",
  "Followers",
];

export const ProfileNavigator = ({
  navigation,
  route,
}: {
  navigation: any;
  route: RouteProp<HomeTabsParamList, "profileTab">;
}) => {
  useLayoutEffect(() => {
    const routeName = getFocusedRouteNameFromRoute(route);

    if (tabBarHiddenRoutes.includes(routeName ?? "")) {
      navigation.setOptions({ tabBarStyle: { display: "none" } });
    } else {
      navigation.setOptions({ tabBarStyle: { display: "flex" } });
    }
  }, [navigation, route]);

  return (
    <Stack.Navigator screenOptions={{ headerShown: false, title: "Profile" }}>
      <Stack.Screen name="ProfileHome" component={ProfileHome} />
      <Stack.Screen
        name="EditProfile"
        component={EditProfileQueryRenderer}
        options={{
          presentation: "fullScreenModal",
          animation: "ios",
        }}
      />
      <Stack.Screen
        name="Members"
        component={Members}
        options={{
          presentation: "fullScreenModal",
        }}
      />
      <Stack.Screen
        name="FriendsAndRequests"
        component={FriendsAndRequests}
        options={{
          presentation: "fullScreenModal",
        }}
      />
      <Stack.Screen
        name="Member"
        component={MemberQueryRenderer}
        options={{
          presentation: "transparentModal",
          animation: "fade",
        }}
      />
      <Stack.Screen
        name="Followers"
        component={Members}
        options={{
          presentation: "fullScreenModal",
          animation: "fade",
        }}
      />
      <Stack.Screen
        name="Share"
        component={ShareScreen}
        options={{
          presentation: "fullScreenModal",
        }}
      />
    </Stack.Navigator>
  );
};
